import { cn } from '@/lib/ui/style-helpers'

import { DELTA_ICON } from './consts'
import { DELTA_LINE_LABELS } from './labels'
import type { Delta } from './types'
import { deltaInkVariants } from './variants'

export type DeltaLineProps = {
  delta: Delta
  className?: string
}

export const DeltaLine = ({ delta, className }: DeltaLineProps) => {
  const ink = deltaInkVariants({ sentiment: delta.sentiment })
  const TrendIcon = delta.trend && DELTA_ICON[delta.trend]

  return (
    <span className={cn('flex items-center gap-1.5 text-body-small', className)}>
      {TrendIcon && <TrendIcon aria-hidden className={cn('size-3.5 shrink-0', ink)} />}
      <span className={cn('tabular-nums text-label-small', ink)}>{delta.value}</span>
      {delta.comparison && (
        <span className='text-main-foreground-tertiary'>
          {DELTA_LINE_LABELS.vsPrefix} {delta.comparison}
        </span>
      )}
    </span>
  )
}
